export const white = "#FFFFFF";
export const background = "#F1EFEE";

const colors = {
  primary: {
    50: "#E0E2F5",
    100: "#C1C5EB",
    200: "#878ED9",
    300: "#4A54C5",
    400: "#2E368F",
    500: "#262D78",
    600: "#1F2460",
    700: "#181C49",
    800: "#0F122E",
    900: "#070917",
    950: "#04040C",
    contrastText: white,
  },
  secondary: {
    50: "#FCF4E6",
    100: "#F5DDB0",
    200: "#F0CC8A",
    300: "#EAB554",
    400: "#E5A633",
    500: "#DF9000",
    600: "#CB8300",
    700: "#9E6600",
    800: "#7B4F00",
    900: "#5E3C00",
  },
  info: {
    50: "#DCFFFF",
    100: "#B3FEFE",
    200: "#6CFEFE",
    300: "#20FDFD",
    400: "#02D0D0",
    500: "#018786",
    600: "#016A6A",
    700: "#015151",
    800: "#003838",
    900: "#001919",
    950: "#000F0F",
  },
  error: {
    50: "#FBE9E9",
    100: "#F2BCBA",
    200: "#EB9B98",
    300: "#E26E6A",
    400: "#DD514D",
    500: "#D42620",
    600: "#C1231D",
    700: "#971B17",
    800: "#751512",
    900: "#59100D",
  },
  warning: {
    50: "#FFFAEB",
    100: "#FEF0C7",
    200: "#FEDF89",
    300: "#FEC84B",
    400: "#FDB022",
    500: "#F79009",
    600: "#DC6803",
    700: "#B54708",
    800: "#93370D",
    900: "#7A2E0E",
  },
  success: {
    50: "#E8F7F0",
    100: "#B7E7D1",
    200: "#94DCBA",
    300: "#64CB9B",
    400: "#45C188",
    500: "#17B26A",
    600: "#15A260",
    700: "#107E4B",
    800: "#0D623A",
    900: "#0A4B2D",
  },
  grey: {
    50: "#FBFBFB",
    100: "#F5F5F4",
    200: "#E7E5E4",
    300: "#D7D3D0",
    400: "#A9A29D",
    500: "#79716B",
    600: "#57534E",
    700: "#44403C",
    800: "#292524",
    900: "#1C1917",
  },
};

export default colors;
